/* Phase 5 · Job Worker master */
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function JobWorkerMaster() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", address: "", gstin: "", work_types: "" });

  const load = () => api.get("/job-workers").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    try {
      await api.post("/job-workers", {
        name: form.name, address: form.address, gstin: form.gstin.trim() || null,
        work_types: form.work_types.split(",").map(s => s.trim()).filter(Boolean),
      });
      setForm({ name: "", address: "", gstin: "", work_types: "" });
      toast.success("Job worker created");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 md:p-6 max-w-4xl" data-testid="jw-workers">
      <h1 className="text-2xl font-bold text-[#0B2340] mb-4">Job Worker Master</h1>

      <div className="bg-white p-4 rounded-lg border border-slate-100 mb-6 grid md:grid-cols-4 gap-2">
        <input placeholder="Name" className="border rounded px-2 py-1.5 text-sm"
          data-testid="jw-worker-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
        <input placeholder="Address" className="border rounded px-2 py-1.5 text-sm"
          value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
        <input placeholder="GSTIN (blank = unreg.)" className="border rounded px-2 py-1.5 text-sm"
          data-testid="jw-worker-gstin" value={form.gstin} onChange={e => setForm({ ...form, gstin: e.target.value })} />
        <input placeholder="Work types (comma)" className="border rounded px-2 py-1.5 text-sm"
          value={form.work_types} onChange={e => setForm({ ...form, work_types: e.target.value })} />
        <button onClick={submit} className="md:col-span-4 px-4 py-2 rounded-full bg-[#B08B49] text-white text-sm w-full md:w-auto"
          data-testid="jw-worker-add">
          + Add job worker
        </button>
      </div>

      <div className="bg-white rounded-lg border border-slate-100 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="text-[11px] uppercase tracking-wider text-[#7C8E9E]">
            <tr className="border-b border-slate-100">
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Address</th>
              <th className="text-left p-3">GSTIN</th>
              <th className="text-left p-3">Work types</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(w => (
              <tr key={w.id} className="border-b border-slate-50">
                <td className="p-3 font-medium">{w.name}</td>
                <td className="p-3 text-xs">{w.address}</td>
                <td className="p-3 text-xs">
                  {w.gstin ? <span>{w.gstin}</span> : <span className="text-amber-700 uppercase">unregistered</span>}
                </td>
                <td className="p-3 text-xs">{(w.work_types || []).join(", ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
